import type { CSSProperties, ReactNode } from "react";
import { DisclosureChevron } from "@/components/common/Disclosure";
import { ICON_BUTTON_DEFAULT_SIZE } from "@/components/common/IconButton";
import { SECTION_HEADER_LABEL_STYLE, SECTION_HEADER_STYLE } from "@/lib/pane-styles";

const HEADING_STYLE: CSSProperties = {
	margin: 0,
	minWidth: 0,
	fontSize: "inherit",
	fontWeight: "inherit",
};

const TOGGLE_STYLE: CSSProperties = {
	display: "flex",
	alignItems: "center",
	gap: 4,
	maxWidth: "100%",
	// 右側のアイコンボタンと同じ高さにして、折りたたみでボタンが消えても行の高さと
	// ラベルの位置が変わらないようにする。
	minHeight: ICON_BUTTON_DEFAULT_SIZE,
	padding: 0,
	border: 0,
	background: "transparent",
	cursor: "pointer",
	font: "inherit",
	letterSpacing: "inherit",
	textTransform: "inherit",
	color: "inherit",
};

interface SectionHeaderProps {
	label: string;
	collapsed: boolean;
	onToggleCollapsed: () => void;
	/** 見出しの右側に並べるアクション。 */
	children?: ReactNode;
	headingTestId?: string;
	toggleTestId?: string;
}

/** 折りたたみできるペインのセクション見出し。幅が足りないラベルは ... でたたむ。 */
export function SectionHeader({
	label,
	collapsed,
	onToggleCollapsed,
	children,
	headingTestId,
	toggleTestId,
}: SectionHeaderProps) {
	return (
		<div style={SECTION_HEADER_STYLE}>
			<h2 data-testid={headingTestId} style={HEADING_STYLE}>
				<button
					type="button"
					onClick={onToggleCollapsed}
					data-testid={toggleTestId}
					style={TOGGLE_STYLE}
				>
					<DisclosureChevron open={!collapsed} size={13} />
					<span style={SECTION_HEADER_LABEL_STYLE}>{label}</span>
				</button>
			</h2>
			{children && <div className="flex shrink-0 items-center gap-0.5">{children}</div>}
		</div>
	);
}
